<template lang="html">
  <div class="cell-container">
    <button class="cell-action" @click="btnClickedHandler($event)" :disabled="disabled">
      A-MIS Link
    </button>
  </div>
</template>
<script>
  export default {
    name: 'LinkButtonCellRenderer',
    data() {
      return {};
    },
    methods: {
      btnClickedHandler($event) {
        $event.stopPropagation();
        this.params.clicked(this.params.data);
      },
    },
    computed: {
      disabled: {
        get() {
          return !this.params.data?.thickUrl;
        },
      },
    },
  };
</script>
<style lang="css">
  .cell-container {
    display: flex;
    justify-content: start;
    align-items: center;
    height: 100%;
    width: 100%;
  }

  .cell-action {
    cursor: pointer;
    background-color: #ca73a6;
    color: white;
    border: none;
    height: 30px;
    border-radius: 5px;
    width: -webkit-fill-available;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 1px;
    transition: all 0.1s ease-out 50ms;
  }

  .cell-action:hover {
    background-color: #fff9fd;
    color: #d463a5;
    border: 1px solid #ca73a6ab;
  }

  .cell-action:disabled {
    background-color: #e0e0e0;
    color: #9e9e9e;
    border: none;
    cursor: normal;
  }
</style>
